export const Trees = {
  path: '/trees',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'trees',
      component: () => import('pages/trees/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.trees.name',
        path: '/trees',
      },
    },
  ],
};
